import Config from '../config.json';
import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  clientId: 'mandant-configuration-client',
  realm: 'master',
  url: process.env.REACT_APP_KEYCLOAK_URL || Config.REACT_APP_KEYCLOAK_URL
});

export default keycloak;
